import styled from 'styled-components';

import { BaseStyle, Select, TabBar } from '@nhl/nhl-breakaway-ui';

import { WithTeam } from '~/core/styleTypes';

export const AdContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.large} {
        min-height: 32px;
        min-width: 400px;
        padding-left: 24px;
    }
`;

export const BioAndSocials = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.small} {
        border-top: 1px solid ${({ theme }) => theme.Surface.border};
        border-bottom: 1px solid ${({ theme }) => theme.Surface.border};
        padding-bottom: 18px;
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        margin: 0 22px 0 10px;
        width: 210px;
    }
`;

export const PlayerBioContainer = styled.div`
    ${BaseStyle.Mixins.screenSizes.medium} {
        flex-direction: row;
    }

    display: flex;
    flex-direction: column;
    padding: 0 24px;

    p {
        margin: 1em 0;
    }

    strong {
        ${BaseStyle.Mixins.fontStyles.ui['14b']}
    }

    ul {
        padding-left: 40px;

        li {
            list-style-type: disc;
        }
    }

    ${BaseStyle.Mixins.screenSizes.small} {
        padding: 0;
    }
`;

export const PlayerBioText = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.body1}
`;

export const PlayerBioName = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['16b']}
`;

export const SmallPlayerBorder = styled.div`
    ${BaseStyle.Mixins.screenSizes.small} {
        border-top: none;
    }
`;

export const SeeMoreButtonStyles = styled.button<WithTeam>`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    ${BaseStyle.Mixins.gaps.small}
    margin: 12px auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-self: center;
    padding: 15px 20px;
    background: ${({ $teamAbbrev, theme }) => ($teamAbbrev && theme.Team[$teamAbbrev]?.primary) || theme.Utility.cta};
    border-radius: 8px;
    color: ${({ $teamAbbrev, theme }) =>
        ($teamAbbrev && theme.Team[$teamAbbrev]?.textOnPrimary) || theme.Text.OppositeSurface.primary};
`;

export const StyledSelect = styled(Select)`
    margin-left: 8px;
    width: fit-content;

    ${BaseStyle.Mixins.screenSizes.small} {
        width: 100%;
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        margin-left: 24px;
    }
`;

export const StyledTabBar = styled(TabBar)`
    .tab-bar {
        justify-content: center;

        .tab-item {
            ${BaseStyle.Mixins.fontStyles.ui['16m']}

            &.selected {
                ${BaseStyle.Mixins.fontStyles.ui['16b']}
            }
        }
    }
`;

export const PlayerSectionHeader = styled.h3`
    width: 100%;
    margin: auto;
    padding-bottom: 16px;
    padding-top: 32px;
    text-align: center;
    text-transform: uppercase;
`;

export const FiveGamesHeader = styled.h4`
    margin-bottom: 16px;
    padding-top: 32px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        padding-top: initial;
    }
`;

export const CenteredLoadingDisplay = styled.div`
    display: flex;
    justify-content: center;
`;
